import React from 'react'
import CTA from './CTA'
import ME from '../../assets/me.png'
// import ME1 from '../../assets/me1.png'
import HeaderSocials from './HeaderSocials'
import './header.css'

const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>Anil Mandal</h1>
        <h5 className="text-light">
          Fullstack Developer
        </h5>
        <CTA/>
        <HeaderSocials/>

        <div className='me'>
          <img src={ME} alt="" />
        </div>

        <a href="#contact" className='scroll__down'rel="noreferrer" >Scroll me</a>
      </div>
    </header>
  )
}

export default Header